<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'TlbsRow',
  
})
</script>
<template>
  <div
    class="tlbs-row"
  >
    <t-row
      :gutter="gutter"
      :justify="justify"
      :align="align"
    >
      <slot />
    </t-row>
  </div>
</template>

<script setup lang="ts"  name="TlbsRow">
interface Props {
  gutter?: number;
  justify?: string;
  align?: string;
}

withDefaults(defineProps<Props>(), {
  gutter: 0,
  justify: 'start',
  align: 'top',
});
</script>
